import { useQuery } from "react-query";
import axios from "infra/http";
import { TimelineLog} from "components/TimelineLogs";


function useLogsConta(id: string | undefined) {
  return useQuery(
    `/v1/conta/${id}/logs`,
    async () => {
      const { data } = await axios.get< TimelineLog[]>(
        `/v1/conta/${id}/logs`
      );

      return data;
    },
    {
      enabled: !!id,
    }
  );
}

export default useLogsConta;
